import { render } from "./UpdateQwilrDefinitionBlock.vue?vue&type=template&id=49b3b4bf&scoped=true"
import script from "./UpdateQwilrDefinitionBlock.vue?vue&type=script&lang=js"
export * from "./UpdateQwilrDefinitionBlock.vue?vue&type=script&lang=js"

import "./UpdateQwilrDefinitionBlock.vue?vue&type=style&index=0&id=49b3b4bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b3b4bf"]])

export default __exports__